import axios from 'axios'

const CLOUDINARY_NAME = 'fandksavings'
const CLOUDINARY_UPLOAD_PRESET = 'fkdobyd1'
const cloudinary_url = `https://api.cloudinary.com/v1_1/${CLOUDINARY_NAME}/image/upload`

export const useCloudinaryUpload = () => {
  let loading: boolean = false
  let error: boolean = false
  let uri: null | string = null

  const upload = async (photo: any) => {
    const formData = new FormData()
    formData.append('file', photo)
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET)
    loading = true
    try {
      const response = await axios.post(cloudinary_url, formData, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
      const { secure_url } = response.data
      loading = false
      uri = secure_url
      return {
        loading,
        uri,
        error,
      }
    } catch (err) {
      loading = false
      uri = null
      error = true
      return {
        loading,
        uri,
        error,
      }
    }
  }

  return {
    upload,
  }
}
